import { Flex, IconButton, Text, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { FaFolderPlus, FaMinus, FaPlus, FaEllipsisV } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";

export default function FolderHeader({
  OnRefetch = () => {},
  OnToggle = () => {},
  OnSelect = () => {},
  OnChange = () => {},
  IsOpen = false,
  Lang,
  texts = {},
  Selected = null
}) {
  const fileManagerTexts = texts?.fileManager || {};

  return (
    <Flex
      fontWeight="bold"
      justify={"space-between"}
      fontSize={{ base: "0.9em", md: "0.9rem" }}
      h={"2rem"}
      px={2}
    >
      <Flex alignItems={"center"}>
        <IconButton
          icon={IsOpen ? <FaMinus /> : <FaPlus />}
          size="xs"
          className="Btn"
          aria-selected={IsOpen}
          onClick={(e) => {
            e.stopPropagation();
            OnToggle();
          }}
          mr={2}
          aria-label={fileManagerTexts.ariaLabels?.toggle || "toggle"}
        />
        <Text as={"span"} onClick={() => OnSelect(null)} cursor={"pointer"}>
          {Lang?.Folder?.TITLE || fileManagerTexts.folders || "Folders"}
        </Text>
      </Flex>
      <Flex alignItems={"center"} gap={1}>
        {/*   */}
        <IconButton
          icon={<MdRefresh />}
          aria-label={fileManagerTexts.ariaLabels?.refreshConversation || "Refresh Conversation"}
          size="xs"
          fontSize={"1rem"}
          className="Btn"
          onClick={() => OnRefetch()}
        />
        
        {/* */}
        <Menu>
          <MenuButton
            as={IconButton}
            icon={<FaEllipsisV />}
            size="xs"
            fontSize={"1rem"}
            className="Btn"
            aria-label={fileManagerTexts.ariaLabels?.moreActions || "More actions"}
          />
          <MenuList>
            <MenuItem
              icon={<FaFolderPlus />}
              onClick={(e) => {
                e.stopPropagation();
                OnChange({
                  IsOpen: true,
                  Tab: "Create",
                  ParentId: Selected
                });
              }}
            >
              {fileManagerTexts.createNewFolder || "Create new folder"}
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}